export default __webpack_public_path__ + "static/media/arrow-circle-right.176960a3.svg";